import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {TokenStorageService} from './token-storage.service';
import {environment} from '../../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private isLoggedInSub: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient, private tokenStorage: TokenStorageService) { }

  login(username: string, password: string): Observable<any> {
    // console.log('LOGIN')

    this.isLoggedInSub.next(true);

    return this.http.post(`${environment.packagesManagerBackendUrl}` + '/auth/login', {
      "username": username,
      "password": password
    }, httpOptions);
  }

  isLoggedIn() {
    // console.log('TOKEN: ' + this.tokenStorage.getToken())
    return this.tokenStorage.getToken() != undefined;
  }

  logout() {
    this.isLoggedInSub.next(false);
    this.tokenStorage.signOut();
  }

  getIsLoggedInSubject() {
    return this.isLoggedInSub;
  }
}
